import React, { useEffect } from 'react';
import './Profile.css'
import { Link as Anchor } from 'react-router-dom';
import ShareWeb from '../ShareWeb/ShareWeb'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons'; // Ícono para productos
import { useCatalogData } from '../CatalogData/CatalogDataProvider';

const fallbackLogo = '/brand/inksu-logo-horizontal.png';

const getSafeExternalUrl = (value) => {
    try {
        const url = new URL(String(value ?? '').trim());
        return url.protocol === 'http:' || url.protocol === 'https:'
            ? url.toString()
            : '';
    } catch (error) {
        return '';
    }
};

const getSafePhone = value => {
    const phone = String(value ?? '').trim().replace(/[^\d+]/g, '');
    return /\d{6,}/.test(phone) ? phone : '';
};

export default function Profile() {
    const { tiendaPrincipal, ensureTienda } = useCatalogData();
    const direccion = String(tiendaPrincipal?.direccion ?? '').trim();
    const telefono = getSafePhone(tiendaPrincipal?.telefono);
    const instagram = getSafeExternalUrl(tiendaPrincipal?.instagram);
    const facebook = getSafeExternalUrl(tiendaPrincipal?.facebook);

    useEffect(() => {
        ensureTienda().catch(() => {});
    }, [ensureTienda]);

    return (
        <div className='profileContain'>
            {tiendaPrincipal?.imagen1 ? (
                <img src={tiendaPrincipal.imagen1} alt={tiendaPrincipal?.nombre || 'INK-SU'} loading="lazy" decoding="async" />
            ) : (
                <img src={fallbackLogo} alt="INK-SU" loading="lazy" decoding="async" />
            )}

            <h2>{tiendaPrincipal?.nombre || 'INK-SU'}</h2>

            <div className='profileText'>
                <p>{tiendaPrincipal?.eslogan || 'Insumos para tecnología'}</p>
                {/* --- ENLACE AÑADIDO --- */}
                {/* Se agrega el enlace a "Productos" como en la referencia */}
                <Anchor to={`/productos`} >
                    <FontAwesomeIcon icon={faShoppingBag} />
                    <span>Todos Los Productos</span>
                </Anchor>
                {direccion && (
                    <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(direccion)}`} target="_blank">
                        {direccion}
                    </Anchor>
                )}
                
                <div className='socials'>
                    {instagram && (
                        <Anchor to={instagram} target="_blank" aria-label='Instagram'>
                            <i className='fa fa-instagram'></i>
                        </Anchor>
                    )}
                    {telefono && (
                        <Anchor to={`https://wa.me/${telefono}`} target="_blank" aria-label='WhatsApp'>
                            <i className='fa fa-whatsapp'></i>
                        </Anchor>
                    )}
                    {facebook && (
                        <Anchor to={facebook} target="_blank" aria-label='Facebook'>
                            <i className='fa fa-facebook'></i>
                        </Anchor>
                    )}
                </div>
            </div>

            <ShareWeb />
        </div>
    )
}
